<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
import config from '@/routing_map.json'
import axios from 'axios'
import router from '@/router'

export default {
  mounted() {
    const browserLang = this.getBrowserLanguage();
    const selectedLang = localStorage.getItem('language') || browserLang;
    this.setLocalLanguage(selectedLang);

    if (localStorage.getItem('authorization')) {
      this.checkAuth()
    } else {
      router.push('login')
      this.verified = true
    }
  },
  methods: {
    checkAuth() {
      const app_data = this
      // eslint-disable-next-line camelcase
      axios.defaults.headers.common.authorization = localStorage.getItem('authorization')
      axios.get(
        `${config.app_url}/login/check-auth`,
      ).then(response => {
        if (response.data.success) {
          app_data.verified = true
          let userInfo = JSON.parse(localStorage.getItem('userInfo'))
          if(userInfo.role && userInfo.role == 'admin')    router.push('adminDashboard')
          else router.push('dashboard')
        } else {
          app_data.$toast.error(response.data.msg);
          app_data.verified = true
          router.push('login')

        }
      }).catch(error => {
        app_data.verified = true
        router.push('login')
        app_data.$toast.error(error.toString());
      })
    },
    getBrowserLanguage() {
      // Tarayıcı dilini alıyoruz
      return navigator.language || navigator.userLanguage || 'en';
    },
    setLocalLanguage(lang) {
      // Dil ayarını localStorage'a kaydediyoruz
      localStorage.setItem('language', lang);
      this.$i18n.locale = lang;  // i18n kütüphanesini kullanıyorsanız bu şekilde ayarlayabilirsiniz
    }
  }
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
